import AntdAvatar from 'components/Avatar'
import Flex from 'components/Flex'
import {
  CommentDiv,
  CommonFlex,
  ContentDiv,
  DetailsDiv,
  DetailsNameDiv,
  HeaderFlex,
  InterviewFlex,
  InterviewInfo,
  InterviewerDiv,
  LeftFlex,
  NameDiv,
  NameInfoDiv,
  Padding,
  RightFlex,
  UploadFlex,
} from 'modules/Drives/ViewDriveRole/IndividualDriveTable/ViewCandidateInfoDrawer/InterviewDetails/CollapseText/style'
import moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'

const CollapseText = ({
  interviewRoundInfo,
  interviwerDeatils,
  candidateInfoData,
}) => {
  const [interViewSchedulerData, setInterViewSchedulerData] = useState({})
  const [interViewUpdaterData, setInterViewUpdaterData] = useState({})
  const [interViewer, setInterViewer] = useState([])

  const getInterViewerDeatils = id => {
    const schedulerData = interviwerDeatils?.filter(data => {
      if (data?._id === id) {
        return data
      }
    })[0]
    return schedulerData
  }

  const getInterviwer = panelList => {
    let panelListId = panelList?.map(data => data?.id)

    const schedulerData = interviwerDeatils?.filter(data => {
      if (panelListId.includes(data?._id)) {
        return data
      }
    })
    return panelListId?.length > 0 && panelListId[0] ? schedulerData : 'NA'
  }

  useEffect(() => {
    setInterViewSchedulerData(
      getInterViewerDeatils(interviewRoundInfo?.interviewScheduler)
    )
    setInterViewUpdaterData(
      getInterViewerDeatils(interviewRoundInfo?.interviewUpdater)
    )
    setInterViewer(getInterviwer(interviewRoundInfo?.panel))
  }, [interviewRoundInfo, interviwerDeatils])

  const getDate = () => {
    return interviewRoundInfo?.date ? (
      <Flex>
        {moment(interviewRoundInfo?.date[0]).format('DD/MM/YYYY') ===
        moment(interviewRoundInfo?.date[1]).format('DD/MM/YYYY') ? (
          <Fragment>
            {interviewRoundInfo?.date &&
              moment(interviewRoundInfo?.date[0]).format('DD/MM/YYYY')}
          </Fragment>
        ) : (
          <Fragment>
            <Fragment>
              {interviewRoundInfo?.date &&
                moment(interviewRoundInfo?.date[0]).format('DD/MM/YYYY')}
            </Fragment>
            &nbsp;-&nbsp;
            <Fragment>
              {interviewRoundInfo?.date &&
                moment(interviewRoundInfo?.date[1]).format('DD/MM/YYYY')}
            </Fragment>
          </Fragment>
        )}
      </Flex>
    ) : (
      <> - </>
    )
  }

  const getOtherDate = () => {
    return (
      <Fragment>
        <Fragment>
          {interviewRoundInfo?.schedualedTime &&
            moment
              .utc(interviewRoundInfo?.schedualedTime?.start)
              .format('DD/MM/YYYY')}
        </Fragment>
        &nbsp;-&nbsp;
        <Fragment>
          {interviewRoundInfo?.schedualedTime &&
            moment
              .utc(interviewRoundInfo?.schedualedTime?.end)
              .format('DD/MM/YYYY')}
        </Fragment>
      </Fragment>
    )
  }

  const getTime = () => {
    return (
      <Flex>
        {interviewRoundInfo?.time ? (
          <Fragment>
            <Fragment>
              {moment(interviewRoundInfo?.time, 'hh:mm:ss').format('hh:mm A')}
            </Fragment>
            &nbsp;-&nbsp;
            <Fragment>
              {moment(
                moment(interviewRoundInfo?.time, 'hh:mm:ss').add(
                  interviewRoundInfo?.duration,
                  'minutes'
                )
              ).format('hh:mm A')}
            </Fragment>
          </Fragment>
        ) : (
          '-'
        )}
      </Flex>
    )
  }

  const getOtherTime = () => {
    return (
      <Flex>
        <Fragment>
          <Fragment>
            {interviewRoundInfo?.schedualedTime && (
              <> {interviewRoundInfo?.schedualedTime?.startAMPMTime}</>
            )}
          </Fragment>
          &nbsp;-&nbsp;
          <Fragment>
            {interviewRoundInfo?.schedualedTime && (
              <> {interviewRoundInfo?.schedualedTime?.endAMPMTime}</>
            )}
          </Fragment>
        </Fragment>
      </Flex>
    )
  }

  return (
    <>
      <HeaderFlex centerVertically>
        <AntdAvatar
          size={30}
          IconName={interViewSchedulerData?.first_name?.charAt(0)}
        />
        <NameDiv>
          {interViewSchedulerData?.first_name}{' '}
          {interViewSchedulerData?.last_name}
        </NameDiv>
        <NameInfoDiv>Scheduled an interview</NameInfoDiv>
        {/* <InterviewTime>
          <EllipseDot />
        </InterviewTime>
        <InterviewTime>
          {moment(interviewRoundInfo?.createdAt).format('hh:mm A')}
        </InterviewTime> */}
      </HeaderFlex>
      <InterviewInfo>
        <DetailsDiv>Details</DetailsDiv>
        <RightFlex column>
          <LeftFlex>
            <DetailsNameDiv>Date</DetailsNameDiv>
            <ContentDiv>
              {interviewRoundInfo?.interview?.interviewType === 'ASSESMENT'
                ? getDate()
                : getOtherDate()}
            </ContentDiv>
          </LeftFlex>

          {!(
            interviewRoundInfo?.interview?.interviewType === 'ASSESMENT' &&
            interviewRoundInfo?.mode === 'EXTERNAL_LINK'
          ) && (
            <LeftFlex>
              <DetailsNameDiv>Time</DetailsNameDiv>
              <ContentDiv>
                {interviewRoundInfo?.interview?.interviewType === 'ASSESMENT'
                  ? getTime()
                  : getOtherTime()}
              </ContentDiv>
            </LeftFlex>
          )}

          <LeftFlex>
            <DetailsNameDiv>Instructions</DetailsNameDiv>
            <ContentDiv style={{ whiteSpace: 'pre-wrap' }}>{interviewRoundInfo?.instructions}</ContentDiv>
          </LeftFlex>
        </RightFlex>
      </InterviewInfo>
      {!!interviewRoundInfo?.feedback?.length > 0 && (
        <Fragment>
          <HeaderFlex centerVertically>
            <AntdAvatar
              size={30}
              IconName={interViewUpdaterData?.first_name?.charAt(0)}
            />
            <NameDiv>
              {interViewUpdaterData?.first_name}{' '}
              {interViewUpdaterData?.last_name}
            </NameDiv>
            <NameInfoDiv>Updated the status</NameInfoDiv>
            {/* <InterviewTime>
              <EllipseDot />
            </InterviewTime>
            <InterviewTime>
              {moment(interviewRoundInfo?.createdAt).format('hh:mm A')}
            </InterviewTime> */}
          </HeaderFlex>
          <InterviewInfo>
            <UploadFlex spaceBetween row>
              <InterviewFlex centerVertically>
                <InterviewerDiv>Interviewed by </InterviewerDiv>
                {!Array.isArray(interViewer) && 'NA'}
                {Array.isArray(interViewer) && (
                  <Fragment>
                    {interViewer?.length === 1 ? (
                      <Fragment>
                        <AntdAvatar
                          size={29}
                          IconName={interViewer[0]?.first_name?.charAt(0)}
                        />
                        <NameDiv>
                          {interViewer[0]?.first_name}{' '}
                          {interViewer[0]?.last_name}
                        </NameDiv>
                      </Fragment>
                    ) : (
                      <Fragment>
                        {interViewer?.slice(0, 5)?.map((data, kIndex) => (
                          <Padding key={data?.first_name + kIndex}>
                            <AntdAvatar
                              size={29}
                              IconName={data?.first_name?.charAt(0)}
                            />
                          </Padding>
                        ))}
                        {interViewer?.length > 5 && (
                          <AntdAvatar
                            size={29}
                            IconName={`+${interViewer?.length - 5}`}
                          />
                        )}
                      </Fragment>
                    )}
                  </Fragment>
                )}
              </InterviewFlex>
            </UploadFlex>
            <DetailsDiv>Remarks</DetailsDiv>
            <RightFlex>
              {interviewRoundInfo?.feedback?.map((item, index) => {
                return (
                  <LeftFlex
                    noBoader={
                      interviewRoundInfo?.feedback?.length - 1 !== index
                    }
                    key={index + item?.value}
                  >
                    <DetailsNameDiv>
                      {item?.type?.toLowerCase()}{' '}
                    </DetailsNameDiv>
                    <ContentDiv>
                      {item?.value}{' '}
                      {interviewRoundInfo?.interview?.interviewType ===
                        'ASSESMENT' && '%'}
                    </ContentDiv>
                  </LeftFlex>
                )
              })}
            </RightFlex>
            {(candidateInfoData?.status === 'HOLD' ||
              candidateInfoData?.status === 'REJECTED') && (
              <CommonFlex column>
                <DetailsDiv>Remark </DetailsDiv>
                <RightFlex>
                  <CommentDiv>
                    {interviewRoundInfo?.remark
                      ? interviewRoundInfo?.remark
                      : '-'}
                  </CommentDiv>
                </RightFlex>
              </CommonFlex>
            )}
            <CommonFlex column>
              <DetailsDiv>Comment </DetailsDiv>
              <RightFlex>
                <CommentDiv>
                  {interviewRoundInfo?.comment
                    ? interviewRoundInfo?.comment
                    : '-'}
                </CommentDiv>
              </RightFlex>
            </CommonFlex>
            {candidateInfoData?.status === 'SHORTLISTED' && (
              <Fragment>
                <CommonFlex column>
                  <DetailsDiv>Strengths </DetailsDiv>
                  <RightFlex>
                    <CommentDiv>
                      {interviewRoundInfo?.strength
                        ? interviewRoundInfo?.strength
                        : '-'}
                    </CommentDiv>
                  </RightFlex>
                </CommonFlex>{' '}
                <CommonFlex column>
                  <DetailsDiv>Weakness </DetailsDiv>
                  <RightFlex>
                    <CommentDiv>
                      {interviewRoundInfo?.weakness
                        ? interviewRoundInfo?.weakness
                        : '-'}
                    </CommentDiv>
                  </RightFlex>
                </CommonFlex>
              </Fragment>
            )}
          </InterviewInfo>
        </Fragment>
      )}
    </>
  )
}

export default CollapseText
